<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import RatingModule from '@/components/modules/RatingModule'

  export default {
    name: 'LocationModule',
    components: {
      RatingModule,
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      options: {
        type: Object,
        default: _ => {},
      },
    },
    computed: {
      ...mapState('ratings', ['rating']),
    },
    async created() {
      await this.getRating(this.ratingId)
    },
    methods: {
      ...mapActions('ratings', ['getRating']),
    },
  }
</script>
